//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../no/SelectNXObjectList.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
let d=[[[1,"FrontCollector",0,"ScCollector",0],[1,"FrontFacetBodies",0,"SelectNXObjectList",0],[1,"RearCollector",0,"ScCollector",0],[1,"RearFacetBodies",0,"SelectNXObjectList",0],[0,"RequirementsControl",1,0],[0,"Standard",1,0],[0,"Visualization",1,0]],[[["index"],"GetPendulum",{R_:{pendulum:"Features.VehicleDesign.PendulumPlacementBuilder"}},1,0],[["description"],"GetPendulum1",{R_:{pendulum:"Features.VehicleDesign.PendulumPlacementBuilder"}},1,0]],[]];
SPLM.Features.VehicleDesign.BumperPendulumBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.BumperPendulumBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.BumperPendulumBuilder.RequirementsControlType = Object.freeze({
    "StandardDriven" : "StandardDriven", "UserDefined" : "UserDefined"});

SPLM.Features.VehicleDesign.BumperPendulumBuilder.VisualizationType = Object.freeze({
    "Curve" : "Curve", "Surface" : "Surface", "CurveandSurface" : "CurveandSurface"});

export default SPLM;